export type CheckoutStage =
    (typeof CheckoutStages)[keyof typeof CheckoutStages];
export const CheckoutStages = {
    InitialPageLoad: "SidenLaster",
    ShoppingCart: "Handlekurv",
    Checkout: "Kasse",
    PlacingOrder: "Fullfører",
} as const;

export type CheckoutStep = (typeof CheckoutSteps)[keyof typeof CheckoutSteps];
export const CheckoutSteps = {
    CustomerInformation: "Kundeinformasjon",
    Delivery: "Levering",
    Payment: "Betaling",
    Confirmation: "Kjøpsbekreftelse",
} as const;

export const CheckoutStepOrder: CheckoutStep[] = [
    CheckoutSteps.CustomerInformation,
    CheckoutSteps.Delivery,
    CheckoutSteps.Payment,
    CheckoutSteps.Confirmation,
];

export type ShippingMethod =
    (typeof ShippingMethods)[keyof typeof ShippingMethods];
export const ShippingMethods = {
    Porterbuddy: "Porterbuddy",
    HomeDelivery: "HomeDelivery",
    PickUpInStore: "PickUpInStore",
    MyPack: "MyPack",
    Retail: "RETAIL",
} as const;
